import { useFeatures } from '@udemy/react-experimentation-provider';
import { useUDData } from '@udemy/ud-data';
import { useHeaderStore } from './use-header-store';
const VALUE_PLANSTARTER_PLAN = 'value_planstarter_plan';
export const useSubscribe = () => {
  var _featureVariantAssign, _udData$Config$price_;
  const headerStore = useHeaderStore();
  const udData = useUDData();
  /** Price country IDs where the Subscribe button is hidden (e.g. Korea, China). */
  const RESTRICTED_SUBSCRIBE_BUTTON_PRICE_COUNTRIES = ['KR', 'CN'];
  const {
    featureVariantAssignments
  } = useFeatures([VALUE_PLANSTARTER_PLAN]);
  const isValuePlanEnabled = ((_featureVariantAssign = featureVariantAssignments.get(VALUE_PLANSTARTER_PLAN)) === null || _featureVariantAssign === void 0 || (_featureVariantAssign = _featureVariantAssign.configuration) === null || _featureVariantAssign === void 0 ? void 0 : _featureVariantAssign.enableValuePlan) || false;
  const subscribeUrl = isValuePlanEnabled ? headerStore.urls.PLANS_AND_PRICING : headerStore.urls.PERSONAL_PLAN;

  // Wait for user context to load to prevent flash of Subscribe button
  if (!('isLoggedIn' in headerStore.userSpecificContext)) {
    return {
      subscribeUrl,
      showSubscribeButton: false
    };
  }

  // MX user detection (same logic as use-plans-and-pricing.ts)
  const isLoggedOut = !headerStore.userSpecificContext.isLoggedIn;
  const isPersonalPlanSubscriber = headerStore.isPersonalPlanSubscriber;
  const hasOrganization = udData.me.is_authenticated && !!udData.me.organization;
  const isInstructor = headerStore.userSpecificContext.isInstructor;
  const isMXUser = !isPersonalPlanSubscriber && !hasOrganization;

  // Hide Subscribe button for Korea and China (based on user's price country, not locale)
  const priceCountryId = (_udData$Config$price_ = udData.Config.price_country) === null || _udData$Config$price_ === void 0 ? void 0 : _udData$Config$price_.id;
  const isRestrictedPriceCountry = !!priceCountryId && RESTRICTED_SUBSCRIBE_BUTTON_PRICE_COUNTRIES.includes(priceCountryId);
  const showSubscribeButton = (isLoggedOut || isMXUser) && !isInstructor && !isRestrictedPriceCountry;
  return {
    subscribeUrl,
    showSubscribeButton
  };
};
//# sourceMappingURL=use-subscribe.js.map